<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="{{isDisabled ? 'agpr-autosizeTextAreaDisable' : 'agpr-autosizeTextArea'}} agpr-contextMenu-parent"
	(click)="onEdit()">
	<ul
		*ngIf="!isDisabled && !editable"
	    class="agpr-contextMenu top right"
	    [ngClass]="{'agpr-autosizeTextArea-iconBlock--mod':editable}"
		role="menu"
		[attr.aria-label]="ariaLabel + ' Text Block'"
		[attr.aria-describedby]="errorsId"
	>
		<li role="menuitem">
			<agpr-button
				class="agpr-autosizeTextArea-edit"
				icon="fa-regular fa-duotone fa-pen"
				(click)="onEdit()"
				[tooltip]="'PageBuilder.briefings.blockIcon.edit'"
				[style]="buttonTypes.contextMenu"
			>
			</agpr-button>
		</li>

	</ul>
	<div [ngClass]="{
			'agpr-autosizeTextAreaDisable-box': isDisabled,
			'agpr-autosizeTextArea-box': !isDisabled,
			'agpr-autosizeTextArea-boxPlaceholder': !content
		  }"
	    *ngIf="!editable"
	    [ngStyle]="boxStyle"
		(click)="onEdit()"
	>
		<span *ngIf="!content">
			<span class="agpr-autosizeTextArea-placeholderIcon {{placeholderIcon}}" aria-hidden="true"></span>
			<span class="agpr-autosizeTextArea-placeholderText">{{placeholder}}</span>
		</span>
		<div *ngIf="content">
			<p *ngFor="let innerContent of getContents(content)">
				{{innerContent}}
			</p>
		</div>
	</div>

	<div *ngIf="editable && isMultiLine">
		<textarea
			class="agpr-autosizeTextArea-input"
			[(ngModel)]="content"
			[ngStyle]="boxStyle"
			[cols]="textAreaCols"
			[maxlength]="textAreaMaxLength"
			#textareaInput
			autosizeTextArea
			(focusout)="onFocusOutTextInput();"
			(focus)="onFocusTextInput();"
			(input)="onTextChange($event);">
		</textarea>
	</div>
	<div *ngIf="editable && !isMultiLine">
		<input
			type="text"
			pInputText
			focus
			class="agpr-autosizeTextArea-input"
			[(ngModel)]="content"
			[ngStyle]="boxStyle"
			[maxlength] = "textAreaMaxLength"
			#textInput
			(focusout)="onFocusOutTextInput();"
			(focus)="onFocusTextInput();"
			(input)="onTextChange($event);"
		/>
		{{ textInput.focus() }}
	</div>
</div>